import React from 'react';
import { withAuthInfo } from '@propelauth/react';
import AssistantList from './AssistantList';
import assistants from './assistants';

const AiAssistants = withAuthInfo(() => <AssistantList assistants={assistants} />);

export default AiAssistants;
